import * as React from 'react';
import { createContext, useEffect, useState } from 'react';
import { SearchModal } from '../components/SearchModal';

export enum SearchKeyOptions {
	CallFromUnknown = 'call-from-unknown',
}

export interface ISearchPayload {
	key: SearchKeyOptions;
}
export interface ISearchContext {
	payload: ISearchPayload;
	setPayload: (payload: ISearchPayload) => void;
	setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
	setShowSearch: React.Dispatch<React.SetStateAction<boolean>>;
	showSearch: boolean;
}

export const SearchContext = createContext<ISearchContext>(null);

export const SearchProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const [showSearch, setShowSearch] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [payload, setPayload] = useState(null);

	useEffect(() => {
		if (searchQuery) {
			setShowSearch(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchQuery]);

	const onRequestClose = () => {
		setShowSearch(false);
		setSearchQuery('');
		setPayload(null);
	};

	return (
		<SearchContext.Provider
			value={{
				payload,
				setPayload,
				setSearchQuery,
				setShowSearch,
				showSearch,
			}}
		>
			{children}
			<SearchModal initialQuery={searchQuery} isOpen={showSearch} onRequestClose={onRequestClose} payload={payload} />
		</SearchContext.Provider>
	);
};

export const useSearch = () => {
	const value = React.useContext<ISearchContext>(SearchContext);
	if (!value) {
		throw new Error('useSearch can only be used within the <SearchProvider /> component');
	}
	return value;
};
